<template>
  <div>
    <div class="page-head">
      <div>
        <h2>服务选项配置</h2>
        <p>按小程序实际使用页面维护选项；调整排序或停用后，对应页面会同步更新。</p>
      </div>
      <el-button type="primary" @click="openCreate">新增选项</el-button>
    </div>

    <el-card shadow="never">
      <div class="location-switch">
        <div class="switch-title">选择要维护的小程序位置</div>
        <el-tabs v-model="activeType" type="card" @tab-click="changeType">
          <el-tab-pane label="全部位置" name="all" />
          <el-tab-pane v-for="item in typeOptions" :key="item.value" :label="item.tabLabel" :name="item.value" />
        </el-tabs>
      </div>

      <div v-if="activeType === 'all'" class="location-overview">
        <button v-for="item in typeOptions" :key="item.value" type="button" class="location-card" @click="selectType(item.value)">
          <span class="location-card-page">{{ item.page }}</span>
          <strong>{{ item.section }}</strong>
          <span>{{ item.path }}</span>
        </button>
      </div>
      <div v-else class="location-current">
        <div class="location-current-main">
          <span class="location-badge">当前维护位置</span>
          <strong>{{ activeTypeInfo.page }} · {{ activeTypeInfo.section }}</strong>
        </div>
        <div class="location-path">小程序路径：{{ activeTypeInfo.path }}</div>
        <div class="location-description">{{ activeTypeInfo.description }}</div>
      </div>

      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="显示名称/系统标识" clearable /></el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="启用" value="active" />
            <el-option label="停用" value="inactive" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column v-if="activeType === 'all'" label="使用页面" min-width="230">
          <template slot-scope="{ row }">
            <div class="table-location">
              <strong>{{ typeInfo(row.option_type).page }}</strong>
              <span>{{ typeInfo(row.option_type).section }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="页面显示名称" min-width="170" />
        <el-table-column prop="option_key" label="系统标识" min-width="180">
          <template slot-scope="{ row }"><span class="system-key">{{ row.option_key }}</span></template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="150">
          <template slot-scope="{ row }">
            <el-switch :value="row.status === 'active'" active-text="启用" inactive-text="停用" @change="changeStatus(row, $event ? 'active' : 'inactive')" />
          </template>
        </el-table-column>
        <el-table-column prop="sort_order" label="页面内排序" width="150">
          <template slot-scope="{ row }"><sort-input :value="Number(row.sort_order || 0)" @change="changeSort(row, $event)" /></template>
        </el-table-column>
        <el-table-column label="操作" width="100"><template slot-scope="{ row }"><el-button type="text" @click="openEdit(row)">编辑</el-button></template></el-table-column>
      </paged-table>
    </el-card>

    <el-dialog :title="drawerMode === 'create' ? '新增服务选项' : '编辑服务选项'" :visible.sync="drawerVisible" width="520px" destroy-on-close>
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="显示名称" prop="name"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="显示位置" prop="option_type">
          <el-select v-model="form.option_type">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.formLabel" :value="item.value" />
          </el-select>
          <div class="field-help">{{ formTypeHelp }}</div>
        </el-form-item>
        <el-form-item label="系统标识" prop="option_key">
          <el-input v-model="form.option_key" :disabled="drawerMode === 'edit'" placeholder="例如 route_dining" />
          <div class="field-help">用于系统识别和匹配图标，创建后不可修改；新增时建议由技术人员填写。</div>
        </el-form-item>
        <el-form-item label="页面内排序">
          <el-input-number v-model="form.sort_order" :min="0" :max="999999" />
          <div class="field-help">数字越小，在对应页面中显示得越靠前。</div>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import SortInput from "../components/SortInput.vue";
import { changeResourceStatus, createResource, listResource, updateResource } from "../api/resources";

export default {
  name: "ServiceNeedOptionsManage",
  components: { PagedTable, SortInput },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      drawerMode: "create",
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      activeType: "all",
      filters: { keyword: "", status: "" },
      form: this.emptyForm(),
      typeOptions: [
        {
          label: "线路服务",
          tabLabel: "定制此线路 · 服务选项",
          formLabel: "定制此线路 → 服务选项",
          value: "route_service",
          page: "定制此线路",
          section: "服务选项",
          path: "线路详情 → 定制此线路 → 服务选项",
          description: "这里的内容会显示为线路定制表单中的可多选服务。"
        },
        {
          label: "服务偏好",
          tabLabel: "高端定制 · 服务偏好",
          formLabel: "高端定制/服务详情 → 服务偏好",
          value: "service_need",
          page: "高端定制 / 服务详情",
          section: "服务偏好",
          path: "高端定制服务 → 服务偏好；服务详情 → 服务偏好/重点咨询",
          description: "这里的内容会显示为高端定制和服务下单时的可多选偏好。"
        },
        {
          label: "酒店等级",
          tabLabel: "高端定制 · 酒店标准",
          formLabel: "高端定制/服务详情 → 酒店标准",
          value: "hotel_level",
          page: "高端定制 / 服务详情",
          section: "酒店标准",
          path: "高端定制服务 → 酒店标准；高端定制服务详情 → 酒店标准",
          description: "这里的内容会显示为高端定制表单中的酒店标准单选项。"
        }
      ],
      rules: {
        option_key: [
          { required: true, message: "请填写系统标识", trigger: "blur" },
          { pattern: /^[a-z][a-z0-9_]{1,79}$/, message: "仅支持2到80位小写字母、数字和下划线", trigger: "blur" }
        ],
        name: [{ required: true, message: "请填写显示名称", trigger: "blur" }],
        option_type: [{ required: true, message: "请选择显示位置", trigger: "change" }]
      }
    };
  },
  mounted() {
    this.fetchList();
  },
  computed: {
    activeTypeInfo() {
      return this.typeInfo(this.activeType);
    },
    formTypeHelp() {
      const info = this.typeInfo(this.form.option_type);
      return info.path ? `该选项将显示在：${info.path}` : "请选择该选项在小程序中的显示位置。";
    }
  },
  methods: {
    emptyForm() {
      return { option_key: "", name: "", option_type: "service_need", status: "active", sort_order: 0 };
    },
    typeInfo(value) {
      return this.typeOptions.find((option) => option.value === value) || {};
    },
    changeType() {
      this.page = 1;
      this.fetchList();
    },
    selectType(value) {
      this.activeType = value;
      this.changeType();
    },
    async fetchList() {
      this.loading = true;
      try {
        const optionType = this.activeType === "all" ? "" : this.activeType;
        const res = await listResource("service-need-options", { ...this.filters, option_type: optionType, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", status: "" };
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.drawerMode = "create";
      this.form = { ...this.emptyForm(), option_type: this.activeType === "all" ? "service_need" : this.activeType };
      this.drawerVisible = true;
    },
    openEdit(row) {
      this.drawerMode = "edit";
      this.form = { ...this.emptyForm(), ...row, sort_order: Number(row.sort_order || 0) };
      this.drawerVisible = true;
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          if (this.form.id) await updateResource("service-need-options", this.form.id, this.form);
          else await createResource("service-need-options", this.form);
          this.$message.success("服务选项已保存");
          this.drawerVisible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    },
    async changeStatus(row, status) {
      await changeResourceStatus("service-need-options", row.id, status);
      this.$message.success(status === "active" ? "选项已启用" : "选项已停用");
      this.fetchList();
    },
    async changeSort(row, sortOrder) {
      await updateResource("service-need-options", row.id, { sort_order: sortOrder });
      this.fetchList();
    }
  }
};
</script>

<style scoped>
.location-switch { margin-bottom: 18px; }
.switch-title { margin-bottom: 12px; color: #303133; font-size: 14px; font-weight: 600; }
.location-switch /deep/ .el-tabs__header { margin-bottom: 0; }
.location-overview { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; margin-bottom: 20px; }
.location-card {
  display: flex;
  min-width: 0;
  padding: 16px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafafa;
  color: #606266;
  font: inherit;
  text-align: left;
  cursor: pointer;
  flex-direction: column;
  gap: 7px;
}
.location-card:hover { border-color: #409eff; background: #ecf5ff; }
.location-card-page { color: #409eff; font-size: 12px; }
.location-card strong { color: #303133; font-size: 15px; }
.location-card span:last-child { overflow: hidden; font-size: 12px; line-height: 1.5; text-overflow: ellipsis; white-space: nowrap; }
.location-current { margin-bottom: 20px; padding: 15px 18px; border-left: 4px solid #409eff; border-radius: 4px; background: #f4f8ff; }
.location-current-main { display: flex; align-items: center; gap: 10px; color: #303133; }
.location-badge { padding: 3px 8px; border-radius: 3px; background: #409eff; color: #fff; font-size: 12px; }
.location-path { margin-top: 9px; color: #606266; font-size: 13px; }
.location-description { margin-top: 6px; color: #909399; font-size: 12px; }
.table-location { display: flex; flex-direction: column; gap: 5px; }
.table-location strong { color: #303133; }
.table-location span { color: #909399; font-size: 12px; }
.system-key { color: #909399; font-family: Menlo, Monaco, Consolas, monospace; font-size: 12px; }
.field-help { margin-top: 6px; color: #909399; font-size: 12px; line-height: 1.5; }
@media (max-width: 1100px) {
  .location-overview { grid-template-columns: 1fr; }
}
</style>
